import { ListExamTypesDiagnosisReport } from '~/domain/usecases/diagnosisReport/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteListExamTypesDiagnosisReport
  implements ListExamTypesDiagnosisReport
{
  private readonly url: string;

  private readonly httpClient: HttpClient<ListExamTypesDiagnosisReport.Model>;

  constructor(
    url: string,
    httClient: HttpClient<ListExamTypesDiagnosisReport.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  listExamTypes = async (
    params: ListExamTypesDiagnosisReport.Params,
  ): Promise<ListExamTypesDiagnosisReport.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}`,
      body: params.body,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
